export default {"src":"/_next/static/image/components/ui/Icon/icons/burger.473a0b624fed271749baf26d6420d6c8.svg","height":24,"width":24};